import { useContext } from "react";
import {
  MdArrowForward,
  MdCheckCircle,
  MdOutlineSecurity,
  MdSpeed,
} from "react-icons/md";
import { AppContext } from "../App";
import billboardImage from "../assets/commandments.png";
import packageImage from "../assets/box.jpg";
import productShowcase from "../assets/banner image.png";

export default function HomeBanner1(props) {
  const appContext = useContext(AppContext);

  const highlights = [
    {
      icon: <MdCheckCircle size={18} />,
      label: "Premium Quality",
    },
    {
      icon: <MdSpeed size={18} />,
      label: "Fast Turnaround",
    },
    {
      icon: <MdOutlineSecurity size={18} />,
      label: "Trusted by Businesses",
    },
  ];

  function goTo(item) {
    appContext.navTo({
      item,
    });
  }

  return (
    <div className="MainBodySection">
      <section className="home-banner-shell" aria-label="Esmeriser hero">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-5 col-md-6">
              <div className="home-banner-copy" data-aos="fade-up">
                <p className="home-banner-kicker">Print. Brand. Promote.</p>

                <h1 className="home-banner-title font-bold">
                  Where Crazy meets <span>Creativity</span>
                </h1>

                <p className="home-banner-text">
                  Creative branding products designed to make every moment
                  memorable — from custom apparel and printed items to trophies,
                  plaques, awards, gifts, and personalized display
                  pieces. We turn ideas into beautiful branded products that
                  stand out and last.
                </p>

                <div className="home-banner-actions">
                  <button
                    type="button"
                    className="home-banner-btn home-banner-btn-primary"
                    onClick={() => goTo("contact_us")}
                  >
                    Get In Touch
                    <MdArrowForward size={18} />
                  </button>

                  <button
                    type="button"
                    className="home-banner-btn home-banner-btn-outline"
                    onClick={() => goTo("gallery")}
                  >
                    View Our Work
                    <MdArrowForward size={18} />
                  </button>
                </div>

                <div className="home-banner-highlights">
                  {highlights.map((highlight) => (
                    <div
                      className="home-banner-highlight"
                      key={highlight.label}
                    >
                      <span className="home-banner-highlight-icon">
                        {highlight.icon}
                      </span>
                      <span>{highlight.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-7 col-md-6">
              <div className="home-banner-visual" data-aos="fade-left">
                <div className="home-banner-city" aria-hidden="true" />
                <img
                  src={billboardImage}
                  alt="Outdoor billboard branding"
                  className="home-banner-billboard"
                />
                <img
                  src={packageImage}
                  alt="Printed product box"
                  className="home-banner-package"
                />
                <img
                  src={productShowcase}
                  alt="Printed shirts, bag, mug, and takeaway cup"
                  className="home-banner-products"
                />
                <div className="home-banner-ground" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
